import {Component, Input} from '@angular/core';
import {
  CategoryItem,
  Competitor,
  CompetitorResults, Country,
  EventItem, FetchEventByIdRequest, FetchRaceByIdRequest,
  Lookups,
  Race, RaceAdditionalPricingItem, RaceCommercialItem, Waypoint
} from '@model';
import {EventService, ExportService, RaceService} from '@services';
import {AbstractComponent} from '@components';
import {take} from "rxjs";

@Component({
  selector: 'app-race-management-component',
  templateUrl: './race-management-component.component.html',
  styleUrls: ['./race-management-component.component.scss']
})
export class RaceManagementComponentComponent extends AbstractComponent {
  @Input() waypointList: Waypoint[] = [];
  @Input() genders: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];
  @Input() competitors: Competitor[] = [];
  @Input() results: CompetitorResults[] = [];
  @Input() race: Race | undefined;
  @Input() eventItem: EventItem | undefined;
  @Input() categories: CategoryItem[] = [];
  @Input() raceCommercialItems: RaceCommercialItem[] = []
  @Input() raceAdditionalItems: RaceAdditionalPricingItem[] = []

  constructor(public raceService: RaceService, public eventService: EventService, private exportService: ExportService) {
    super();
  }

  downloadStartList() {
    this.exportService.downloadStartList(this.eventItem!.id!, this.race!.id!);
  }

  onRefreshCounters() {
    this.raceService.findRaceByIdProtected(new FetchRaceByIdRequest(this.race!.id!), false)
        .pipe(take(1)).subscribe((race: Race | null) => {
        this.race = race ?? this.race;
    })
    this.eventService.findEventByIdProtected(new FetchEventByIdRequest(this.eventItem!.id!), false, false).subscribe(eventItem => {
      this.eventItem = eventItem ?? this.eventItem;
    });
  }

}
